import bus from '@/shared/event-bus.js';

export default {
    mounted () {
        var self = this;

        bus.$on('update:scroll', () => {
            self.loadContentOnScroll();
        });
        bus.$on('update:resize', () => {
            self.adjustHeaderOnResize();
        });
    },
    methods: {
        loadContentOnScroll () {
            if (this.tableData && this.tableData.length > 0 && !this.isFixedTable) {
                if (!this.containerScrolling) {
                    window.fixHeaders('scrollTable');
                    this.tableScrolling();
                }
            }
        },

        adjustHeaderOnResize () {
            if (this.tableData && this.tableData.length > 0) {
                if (this.fromPage !== 'projectDetails') {
                    window.fixHeaders('scrollTable');
                } else {
                    window.fixHeaders('project-basics', true);
                    this.fixSubPageTableHeaders();
                }
            }
        },

        tableScrolling () {
            var self = this,
                yOffset = this.containerScrolling ? this.scrollY : window.pageYOffset;


            self.scrollingTimer++;

            setTimeout(() => {
                self.scrollingTimer--;

                if (self.scrollingTimer === 0 && yOffset !== 0 && document.getElementById('scrollTable')) {
                    if (yOffset > (document.body.scrollHeight / 3)) {
                        if (self.tableMeta && self.tableData.length < self.tableMeta.total) {
                            if (!self.table.loadingMoreData) {
                                if (self.fromPage === 'publications-search') {
                                    self.table.offset += self.table.limit;
                                    self.initTableData();
                                } else {
                                    if (self.$parent && self.$parent.setProjectPageNumber) {
                                        self.$parent.setProjectPageNumber(self.$route.name);
                                    } else {
                                        bus.$emit('set:projectNumber', self.$route.name);
                                    }
                                }
                            }
                        } else {
                            self.limitBy = self.tableData.length;
                        }
                    } else {
                        self.limitBy += self.limitByAmount;
                    }
                }
            }, 10);
        },

        fixSubPageTableHeaders (container) {
            var tables = document.getElementsByClassName('fixed-within'),
                i,
                tableContainer,
                containerParent,
                curTableObj,
                curSection,
                self = this,
                totalResultCnt = 0,
                frontEndPagination = true,
                parentObj = self.$parent,
                newsType = '';

            if (container) {
                tables = document.getElementById(container).querySelectorAll('.fixed-within')
            }
            for (i = 0; i < tables.length; i++) {
                curTableObj = tables[i];
                tableContainer = window.closest(curTableObj, '.data-section');
                containerParent = window.closest(curTableObj, '.project-description');
                curSection = containerParent.getAttribute('id');


                window.sizeTableHeader(containerParent.getAttribute('id'));
                tableContainer.onscroll = function () {
                    frontEndPagination = true;
                    curTableObj = this.querySelector('.fixed-within');
                    parentObj = self ? self.$parent : null;
                    if (curTableObj) {
                        containerParent = window.closest(curTableObj, '.project-description');
                        curSection = containerParent.getAttribute('id');
                        curTableObj.style.top = this.scrollTop + 'px';
                        switch (curSection) {
                            case 'history':
                                totalResultCnt = self.$store.state.projectDetails.history.meta.total;
                                break;
                            case 'sub-Projects':
                                totalResultCnt = self.$store.state.projectDetails.subProjects.meta.total;
                                break;
                            case 'patents':
                                totalResultCnt = self.$store.state.projectDetails.patents.meta.total;
                                break;
                            case 'publications':
                                totalResultCnt = self.$store.state.projectDetails.publications.meta.total;
                                break;
                            case 'clinical-studies':
                                totalResultCnt = self.$store.state.projectDetails.clinicalStudies.meta.total;
                                break;
                            case 'press-release':
                                frontEndPagination = false;
                                newsType = 'PressRelease';
                                totalResultCnt = self.table.offset + self.table.limit + 1;
                                if (!self.$store.state.newsResults[newsType].meta.properties.lastItem || self.$store.state.newsResults[newsType].meta.properties.lastItem === null) {
                                    totalResultCnt = self.table.offset + self.table.limit;
                                }
                                if (self.table.offset + self.table.limit < self.$store.state.newsResults[newsType].results.length) {
                                    frontEndPagination = true;
                                }
                                break;
                            case 'research-matters':
                                frontEndPagination = false;
                                newsType = 'ResearchMatters';
                                totalResultCnt = self.$store.state.newsResults[newsType].newsCount ? self.$store.state.newsResults.ResearchMatters.newsCount.total : self.$store.state.newsResults.ResearchMatters.results.length;
                                break;
                            case 'AIRS':
                            case 'ARRA':
                            case 'AIMRS':
                                newsType = curSection;
                                frontEndPagination = false;
                                totalResultCnt = self.$store.state.newsCount[curSection].total ? self.$store.state.newsCount[curSection].total : self.$store.state.newsResults[curSection].results.length;
                                break;
                            case 'publications':
                                totalResultCnt = self.$store.state.projectDetails.publications.meta.total;
                                break;
                        }
                        if (this.scrollTop > (this.scrollHeight / 3) && self.table.offset + self.table.limit < totalResultCnt) {
                            if (frontEndPagination) {
                                self.table.offset += self.table.limit;
                                self.initTableData();
                            } else {
                                if (!self.table.loadingMoreData) {

                                    //TODO: this is a temp workaround to the hardcoding of .$parent ....dataTables should be
                                    //refactored ASAP to remove reference to .$parent!
                                    var realParent = parentObj.setProjectPageNumber ?
                                        parentObj :
                                        self.$parent.$parent.setProjectPageNumber ? self.$parent.$parent
                                            : undefined;


                                    realParent.setProjectPageNumber(newsType);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}